import axios from "axios";

export const coingeckoAPI = axios.create({
  baseURL: "https://api.coingecko.com/api/v3",
});
